import React from 'react';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { Field, useFormikContext } from 'formik';
import { Message } from 'primereact/message';
import { useParams } from 'react-router-dom';
import { FormikRadio, LegacyInputTextComponent } from '../../../components/prime-formik';
import FormikTextCopiable from '../../../components/formik-components/FormikTextCopiable';

const i18n = defineMessages({
  deleteModeOnlySuperLink: {
    id: 'lbl.deleteMode_only_super_link',
    defaultMessage: 'Delete SuperLink but not the respondents and not the assessments.',
  },
  deleteModeSupAndNotEmp: {
    id: 'lbl.deleteMode_sup_and_not_emp',
    defaultMessage: 'Delete SuperLink and all assessments and respondents that are not employees.',
  },
  deleteModeSupAndEmp: {
    id: 'lbl.del_sup_and_all_emp',
    defaultMessage: 'Delete SuperLink and all assessments and respondents created via this SuperLink.',
  },
});

const ConfirmForm = () => {
  const { errors, setFieldValue } = useFormikContext();
  const { formatMessage } = useIntl();
  const { superLinkId } = useParams();

  return (
    <>
      <div>
        <Field
          id="deleteMode_only_super_link"
          name="deleteMode"
          component={FormikRadio}
          labeTextId="lbl.del_sup_only"
          labelDefaultText={formatMessage(i18n.deleteModeOnlySuperLink)}
          value="ONLY_SUPERLINK"
          inputValue="ONLY_SUPERLINK"
          setFieldValue={setFieldValue}
        />
        <Field
          id="deleteMode_sup_and_not_emp"
          name="deleteMode"
          component={FormikRadio}
          labeTextId="lbl.del_sup_and_not_emp"
          labelDefaultText={formatMessage(i18n.deleteModeSupAndNotEmp)}
          value="WITH_NOT_EMPLOYEE"
          inputValue="WITH_NOT_EMPLOYEE"
          setFieldValue={setFieldValue}
        />
        <Field
          id="deleteMode_sup_and_emp"
          name="deleteMode"
          component={FormikRadio}
          labeTextId="del_sup_and_all_emp"
          labelDefaultText={formatMessage(i18n.deleteModeSupAndEmp)}
          value="ALL_RELATED"
          inputValue="ALL_RELATED"
          setFieldValue={setFieldValue}
        />
        {(errors && errors.deleteMode) && <Message severity="error" text={errors.deleteMode} />}
      </div>
      <div>
        <FormattedMessage
          id="lbl.del_confirm.warning"
          defaultMessage="This action cannot be undone."
        >
          {text => <strong>{text}</strong>}
        </FormattedMessage>
      </div>
      <div className="form-group group-normalized">
        <FormattedMessage id="lbl.confirmation_code" defaultMessage="Confirmation code">
          {text => <label htmlFor="confirmation_code">{text}</label>}
        </FormattedMessage>
        <Field
          name="confirmation_code"
          keyValue={superLinkId}
          component={FormikTextCopiable}
          readOnly
        />
      </div>
      <div className="form-group group-normalized">
        <FormattedMessage id="lbl.confirmation_code_retype" defaultMessage="Please type the confirmation code">
          {text => <label htmlFor="re_confirmation_code">{text}</label>}
        </FormattedMessage>
        <div>
          <Field
            name="re_confirmation_code"
            component={LegacyInputTextComponent}
          />
        </div>
      </div>
    </>
  );
};

export default ConfirmForm;
